import type { Editor as TiptapEditor, JSONContent } from '@tiptap/react';
import Editor from './Editor';
import { DukeTiptapEditorContext, type UploadResult } from './useDukeTiptapEditor';

/**
 * Tiptap editor component. Import and use this component to render the editor.
 * When the content changes, the `onChange` function will be called with the new content.
 * If `readOnly` is set to true, the editor will be read-only.
 * `initialContent` can be passed as a JSONContent object.
 * `onEditorReady` hands the underlying Tiptap instance to the caller once it
 * exists, so a host can drive the editor from outside (e.g. wire undo/redo into
 * a toolbar). Optional, so existing call sites are unaffected.
 */
export function DukeTiptapEditor({
  initialContent,
  onChange,
  readOnly = false,
  uploadFn,
  onEditorReady,
}: {
  initialContent?: JSONContent;
  onChange: (content: JSONContent) => void;
  readOnly?: boolean;
  uploadFn?: (file: File) => Promise<UploadResult>;
  onEditorReady?: (editor: TiptapEditor) => void;
}) {
  return (
    <DukeTiptapEditorContext.Provider value={{ uploadFn }}>
      <Editor
        initialContent={initialContent}
        onChange={onChange}
        readOnly={readOnly}
        onEditorReady={onEditorReady}
      />
    </DukeTiptapEditorContext.Provider>
  );
}

export default DukeTiptapEditor;
